import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Alert, Button } from 'reactstrap';

import Cookies from '../../lib/cookies';
import { isCookiePresent, isUserLoggedIn, isBrowser } from '../../lib/utils';

export default class CookiesConsent extends Component {
  cookieName = 'cookieConsent';

  state = { visible: true };

  onDismiss = () => {
    this.setState({ visible: false });
    Cookies.prototype.setCookie(this.cookieName, 1, 7);
  };

  render() {
    return (
      <Fragment>
        {isBrowser() && !isCookiePresent(this.cookieName) && !isUserLoggedIn() && (
          <div className="cookies">
            <Alert color="cookie" isOpen={this.state.visible}>
              <div>
                By using our site, you acknowledge that you have read and understand our{' '}
                <Link to="/policies/cookies">Cookie Policy</Link>,{' '}
                <Link to="/policies/privacy">Privacy Policy</Link>, and our{' '}
                <Link to="/policies/terms-services">Terms of Service</Link>. <br />
              </div>
              <div>
                <Button size="md" color="outline" onClick={this.onDismiss}>
                  I Agree
                </Button>
              </div>
            </Alert>
          </div>
        )}
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Cookies/CookiesConsent.jsx